export default __webpack_public_path__ + "static/media/GPS_tracking_line.bea95003.svg";